import { useEffect } from "react"
import { toast } from "react-toastify"

const settings = {
  position: "top-center",
  autoClose: 5000,
  hideProgressBar: false,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
  progress: undefined,
}

export const useToastError = (stateAndMessage) => {
  useEffect(() => {
    if (stateAndMessage) {
      toast.error(stateAndMessage.message, settings)
    }
    return () => {
      toast.dismiss()
    }
  }, [stateAndMessage])
}
